import { Component, OnInit } from '@angular/core';
import { ComunicadosService } from '../comunicados.service';

@Component({
  selector: 'app-mayoristas-comunicados-marketing',
  templateUrl: './mayoristas-comunicados-marketing.component.html',
  styleUrls: [
  	'./mayoristas-comunicados-marketing.component.css',
  	'../../assets/scss/styles.scss',
	'../../assets/scss/general-board.scss', 
    '../../assets/scss/fonts.scss',    
    '../../assets/ema/main.scss',
  ]
})
export class MayoristasComunicadosMArketingComponent implements OnInit {
  public comunicados;
  constructor(private comunicadosService: ComunicadosService) { }

  ngOnInit() {
    this.comunicadosService.getAllComunicadosbyCategory('Marketing')
      .then(response => {
        this.comunicados = response;
      })
      .catch(err => console.error(err));
  }

}
